import React from 'react';
import { Link } from 'react-router-dom';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

interface ContactButtonProps {
  vehicleId?: string;
  vehicleName?: string;
  stockNumber?: string;
  variant?: 'primary' | 'secondary' | 'small';
  className?: string;
}

const ContactButton: React.FC<ContactButtonProps> = ({ 
  vehicleId, 
  vehicleName,
  stockNumber,
  variant = 'primary',
  className = '' 
}) => {
  const getButtonClasses = () => {
    const baseClasses = "inline-flex items-center justify-center font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
    
    switch (variant) {
      case 'primary':
        return `${baseClasses} px-6 py-3 bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500`;
      case 'secondary':
        return `${baseClasses} px-4 py-2 bg-gray-100 text-gray-700 hover:bg-gray-200 focus:ring-gray-500`;
      case 'small':
        return `${baseClasses} px-3 py-1.5 text-sm bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500`;
      default:
        return `${baseClasses} px-6 py-3 bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500`;
    }
  };

  const getIconSize = () => {
    switch (variant) {
      case 'small':
        return 'h-4 w-4';
      default:
        return 'h-5 w-5';
    }
  };

  // Build the contact URL with pre-filled information
  const params = new URLSearchParams();
  if (vehicleId) params.set('vehicle', vehicleId);
  if (vehicleName) params.set('name', vehicleName);
  if (stockNumber) params.set('stock', stockNumber);
  const contactUrl = `/contact${params.toString() ? `?${params.toString()}` : ''}`;

  return (
    <Link
      to={contactUrl}
      className={`${getButtonClasses()} ${className}`}
    >
      <ChatBubbleLeftRightIcon className={`${getIconSize()} mr-2`} />
      Свържете се с нас
    </Link>
  );
};

export default ContactButton;
